// Orari (24 ore, stesso giorno) e importi in euro: stesse regole del backend (backend/src/competenze/importi.js).
// La durata si calcola sempre dagli orari e si mostra in ore e minuti (h:mm), mai in decimali.

// "9:30", "09.30", "0930" -> "09:30"; vuoto -> null; altro -> { errore }
export function normalizzaOrario(valore) {
  const s = String(valore ?? '').trim();
  if (!s) return { valore: null };
  const m = s.match(/^(\d{1,2})[:.,]?(\d{2})$/);
  if (!m || Number(m[1]) > 23 || Number(m[2]) > 59) return { errore: `Orario non valido (${s}): usa il formato 24 ore HH:MM, es. 09:30` };
  return { valore: `${m[1].padStart(2, '0')}:${m[2]}` };
}

const minutiDi = hhmm => Number(hhmm.slice(0, 2)) * 60 + Number(hhmm.slice(3, 5));

// { minuti } | { errore } | { vuoto: true } (nessun orario)
export function durataDaOrari(dalle, alle) {
  const d = normalizzaOrario(dalle);
  const a = normalizzaOrario(alle);
  if (d.errore) return { errore: d.errore };
  if (a.errore) return { errore: a.errore };
  if (!d.valore && !a.valore) return { vuoto: true };
  if (!d.valore || !a.valore) return { errore: 'Indica sia Dalle sia Alle (o lascia vuoti entrambi)' };
  if (minutiDi(a.valore) <= minutiDi(d.valore)) return { errore: `Alle (${a.valore}) deve essere dopo Dalle (${d.valore}): gli orari sono nello stesso giorno` };
  return { minuti: minutiDi(a.valore) - minutiDi(d.valore) };
}

// Testo in euro -> numero (null se vuoto) oppure { errore }
export function parseEuro(valore, etichetta = 'Importo') {
  let s = String(valore ?? '').trim().replace(/\s|€/g, '');
  if (!s) return { valore: null };
  if (/^\d{1,3}(\.\d{3})+(,\d+)?$/.test(s)) s = s.replace(/\./g, '').replace(',', '.');
  else s = s.replace(',', '.');
  if (!/^-?\d+(\.\d+)?$/.test(s)) return { errore: `${etichetta} non valido: scrivi un importo in euro, es. 12,50` };
  if (s.startsWith('-')) return { errore: `${etichetta} non può essere negativo` };
  if ((s.split('.')[1] || '').length > 2) return { errore: `${etichetta}: al massimo due decimali` };
  return { valore: Math.round(Number(s) * 100) / 100 };
}

// 12.5 -> "12,50" (formato italiano); vuoto per null
export function formattaEuro(n) {
  if (n === null || n === undefined || n === '') return '';
  return Number(n).toLocaleString('it-IT', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

// Importo suggerito: minuti ÷ 60 × tariffa oraria del ruolo di chi ha svolto, al centesimo (come nel backend)
export function suggerisciImporto({ dalle, alle, eseguito_da, operatori, tariffe }) {
  const d = durataDaOrari(dalle, alle);
  if (d.vuoto || d.errore) return { stato: 'senza_orari' };
  const chi = (operatori || []).find(o => String(o.id) === String(eseguito_da));
  if (!chi || !chi.ruolo_tariffario) return { stato: 'ruolo_mancante' };
  const t = (tariffe || []).find(x => x.ruolo === chi.ruolo_tariffario);
  if (!t) return { stato: 'tariffa_mancante' };
  return { stato: 'ok', importo: Math.round(d.minuti * Math.round(t.tariffa * 100) / 60) / 100, minuti: d.minuti };
}
